import { Module } from 'vuex'
import { RootState } from '../types'
import {
  DialogFormType,
  TreeDataType,
} from '@/views/repository/resource/config/type'
import type { fileMetaType, fileListType } from '@/api/public_resource/type'

export interface ResourceState {
  activeTab: number | string
  visible: boolean
  dialogFormInfo: DialogFormType
  cascaderValue: { id: string; level: number; change: boolean }
  tagIdsList: TreeDataType[]
  viewDialog: {
    id: number
    visible: boolean
    preview_urls: string[]
    name: string
    type: number
    file_list: fileListType[]
    file_meta: fileMetaType
  }
}

export const state: ResourceState = {
  activeTab: 0,
  visible: false,
  dialogFormInfo: {
    id: 0,
    operation: '',
  },
  cascaderValue: {
    id: '',
    level: 0,
    change: false,
  },
  tagIdsList: [],
  // 预览弹框数据
  viewDialog: {
    id: 0,
    visible: false,
    preview_urls: [],
    name: '',
    type: 0,
    file_list: [],
    file_meta: {
      skeleton_count: 0,
      mesh_count: 0,
      material_count: 0,
      skin_count: 0,
      skeleton_names: [],
      face_count: 0,
      vertex_count: 0,
      fps: 0,
      frames: 0,
    },
  },
}
const namespaced = true

const resource: Module<ResourceState, RootState> = {
  namespaced,
  state,
  mutations: {
    updateActiveTab(state, value) {
      state.activeTab = value
    },
    updateVisible(state, value) {
      state.visible = value
    },
    updateViewDialog(state, value) {
      state.viewDialog = { ...state.viewDialog, ...value }
    },
  },
}

export default resource
